import { useCallback } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import { generateCsvFileName, sanitizeFileName } from "../../../../hooks/useFileNaming";

function buildEntitiesExportBaseName(request) {
  const entityType = request?.entity_type ? `${request.entity_type}` : "all_entities";
  const hasFilters =
    Array.isArray(request?.filters) && request.filters.length > 0;
  const sortBy = request?.sort_by ? `${request.sort_by}` : null;
  const sortDir =
    request?.sort_dir === "asc" || request?.sort_dir === "desc"
      ? request.sort_dir
      : null;
  const columnsCount = Array.isArray(request?.columns)
    ? `${request.columns.length}`
    : null;

  const parts = [
    "entities",
    entityType,
    hasFilters ? "filtered" : null,
    sortBy ? `sorted_${sortBy}${sortDir ? `_${sortDir}` : ""}` : null,
    columnsCount ? `cols_${columnsCount}` : null,
  ].filter(Boolean);

  return parts.join("_");
}

function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export default function useEntitiesExport() {
  const { exportEntities } = useAPI();

  const exportEntitiesCsv = useCallback(
    async (exportRequest) => {
      const response = await exportEntities(exportRequest);
      const blob = new Blob([response.data], { type: "text/csv" });
      const filename = sanitizeFileName(
        generateCsvFileName(buildEntitiesExportBaseName(exportRequest))
      );
      downloadBlob(blob, filename);
      return response;
    },
    [exportEntities]
  );

  return { exportEntities: exportEntitiesCsv };
}


